import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
export type Sales_Crm_Web_Common_AttendanceFragment = {
   __typename?: 'BaseUserAttendance'
   clockIn?: string | null
}

export const Sales_Crm_Web_Common_AttendanceFragmentDoc = gql`
   fragment Sales_Crm_Web_Common_Attendance on BaseUserAttendance {
      clockIn
   }
`
